import { Link } from "react-router-dom";
import { ArrowRight, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import newRoom from "@/assets/fenster-neu-raum.jpg.asset.json";
import { SPONSORED_OPENING_WINDOWS, SPONSORED_FIXED_WINDOWS, windowSponsorshipPrice, formatWindowPrice } from "@/lib/window-sponsorship";

export function WindowSponsorshipTeaser() {
  const done = SPONSORED_OPENING_WINDOWS + SPONSORED_FIXED_WINDOWS;
  const percent = Math.round((done / 16) * 100);
  return <section className="py-12 md:py-16 bg-primary/10 border-y border-primary/30" aria-labelledby="fenster-teaser">
    <div className="container mx-auto px-4 max-w-6xl grid md:grid-cols-2 gap-8 md:gap-12 items-center">
      <img src={newRoom.url} alt="Eventraum mit neuen Bogenfenstern im Alten Stemke Werk" loading="lazy" className="w-full aspect-[4/3] object-cover rounded-lg shadow-lg" />
      <div>
        <p className="text-primary font-semibold flex items-center gap-2 mb-3"><Heart size={18} aria-hidden="true" />Jetzt mitmachen</p>
        <h2 id="fenster-teaser" className="font-display text-3xl md:text-4xl font-bold">Werde Fensterpate!</h2>
        <p className="mt-4 text-lg text-muted-foreground">Gemeinsam erneuern wir 16 historische Fenster im Eventraum. Ganz oder zur Hälfte – mit deinem Logo auf Milchglas für 5 Jahre.</p>
        <p className="mt-4 font-display text-xl font-bold">ab {formatWindowPrice(windowSponsorshipPrice("festverglast", "halb"))} brutto</p>
        <div className="mt-6">
          <div className="flex justify-between text-sm mb-2"><span className="font-semibold">{done} von 16 Fenstern gesponsert</span><span className="text-muted-foreground">{percent} %</span></div>
          <div role="progressbar" aria-label="Gesponserte Fenster" aria-valuemin={0} aria-valuemax={16} aria-valuenow={done} className="h-3 rounded-full bg-background overflow-hidden border border-border"><div className="h-full bg-primary" style={{ width: `${percent}%` }} /></div>
        </div>
        <Button asChild size="lg" className="mt-8 gap-2"><Link to="/fensterpatenschaft">Fensterpate werden<ArrowRight size={18} /></Link></Button>
      </div>
    </div>
  </section>;
}
